import React from 'react'
import {useSystemStateMutation,  } from '../store/ReactWebSiteApi';
import { message} from 'antd';
function AppOnOff(props) {
    const [systemState] = useSystemStateMutation()
    return (
        <>
            {(props.esv_state==='1') ? <>
                <a onClick={() => {
                    systemState({esv_id:props.esv_id,esv_state:'1'}).then((res) => {
                        if(res.data.Status==='success'){
                            message.info('上架成功！')
                        }else{
                            message.error('上架失败！' + res.data.Message)
                        }
                    })
                }}>上架</a>
            </>:<>
                <a onClick={() => {
                    systemState({esv_id:props.esv_id,esv_state:'2'}).then((res) => {
                        if(res.data.Status==='success'){
                            message.info('下架成功！')
                        }else{
                            message.error('下架失败！' + res.data.Message)
                        }
                    })
                }}>下架</a>
            </>}
        </>
    )
}

export default AppOnOff